const statuses = {
  tickets : {
    "initiated": "Not Checked In",
    "completed": "Checked In",
    "pending": "Pending Approval",
  },
  orders : {
    "pending": "Pending",
    "completed": "Completed",
    "refund": "To be Refunded",
    "refunded": "Refunded",
    "failed": "Failed",
  },
  subscriptions: {
    "active": "Active",
    "expired": "Expired",
    "expiring": "Expiring",
  },
  organizations: {
    "live": "Live",
    "draft": "Draft",
    "suspended": "Suspended",
  },
  merch: {
    "initiated": "Not Collected",
    "completed": "Collected",
    "pending": "Pending Approval",
  }
};

// SELL05 — the shipping ladder. Its own label rather than `status`, whose
// param the API already maps to redeem_state.
const fulfillmentStates = {
  "pending": "Pending",
  "shipped": "Shipped",
  "delivered": "Delivered",
};

const methods = {
  "stripe": "Card",
  "mbway": "MBWay",
  "bizum": "Bizum",
  "utrust": "Crypto",
  "cash": "Cash",
  "paypal": "PayPal",
};

const invoiceOptions = {
  true: "Has billing details",
  false: "No billing details"
};

const ticketingOptions = {
  true: "Has Ticketing",
  false: "No Ticketing",
};

const roundApproachMorOptions = {
  true: "Has MoR",
  false: "No MoR",
};

export const getFilterOptions = (label, table) => {
  switch (label) {
    case "status":
      return getStatusFilterOptions(table);
    case "fulfillment_state":
      return Object.keys(fulfillmentStates).map((state, index) => ({ identifier: state, id: index }));
    case "method":
      return getMethodFilterOptions();
    case "invoice":
      return getInvoiceFilterOptions();
    case "ticketing":
      return getTicketingFilterOptions();
    case "mor":
      return getRoundApproachMorFilterOptions();
    default:
      return [];
  }
};

export const getUserFriendlyIdentifier = (label, table, identifier) => {
  switch (label) {
    case "status":
      return getStatusUserFriendlyIdentifier(table, identifier);
    case "fulfillment_state":
      return fulfillmentStates[identifier];
    case "method":
      return getMethodUserFriendlyIdentifier(identifier);
    case "invoice":
      return invoiceOptions[identifier];
    case "ticketing":
      return ticketingOptions[identifier];
    case "mor":
      return roundApproachMorOptions[identifier];
    default:
      return identifier;
  }
};

const getStatusFilterOptions = (table) => { 
  return Object.keys(statuses[table]).map((status, index) => ({ identifier: status, id: index })); 
};

const getStatusUserFriendlyIdentifier = (table, identifier) => {
  return statuses[table][identifier];
};

const getMethodFilterOptions = () => { 
  return Object.keys(methods).map((method, index) => ({ identifier: method, id: index })); 
};

const getMethodUserFriendlyIdentifier = (method) => {
  return methods[method];
};

const getInvoiceFilterOptions = () => { 
  return Object.keys(invoiceOptions).map((option, index) => ({ identifier: option, id: index })); 
};

const getTicketingFilterOptions = () => {
  return Object.keys(ticketingOptions).map((option, index) => ({ identifier: option, id: index }));
};

const getRoundApproachMorFilterOptions = () => {
  return Object.keys(roundApproachMorOptions).map((option, index) => ({ identifier: option, id: index }));
};